import 'globals.css'

import Steps from 'pages/Steps'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { useLandingAvailabilityQuery } from 'redux/api/status.api'
import { setError } from 'redux/store/slices/error-slice'
function App() {
  const { data } = useLandingAvailabilityQuery(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (data?.data?.status === false) {
      dispatch(setError({ code: 'LANDING_NOT_AVAILABLE', description: 'Идут тенхнические работы' }))
    }
  }, [data])

  return (
    <BrowserRouter>
      <Steps />
    </BrowserRouter>
  )
}

export default App
